import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@material-ui/core/styles'
import { Container, Grid, Paper, Box, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Cancel from '@material-ui/icons/Cancel'
import Moment from 'react-moment'
import moment from 'moment'

import TrackerHeaderComponent from './TrackerHeaderComponent'
import TrackerDailyEngagementComponent from './TrackerDailyEngagementComponent'
import TrackerTeasersTrailersComponent from './TrackerTeasersTrailersComponent'
import TrackerOnBoarding from './TrackerOnBoarding'
import TrackerTabComponent from './TrackerTabComponent'
import Spinner from '../../components/Spinner'
import { theme } from '../../classes/Themes'
import { styles } from '../../classes/Styles'
import './TrackerComponent.scss'

export class TrackerComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    trackerId: PropTypes.string,
    tracker: PropTypes.object,
    trackerPlan: PropTypes.object,
    trackerTimelineMetrics: PropTypes.object,
    primaryEntityDetails: PropTypes.object,
    teasersAndTrailers: PropTypes.object,
    wordCloud: PropTypes.object,
    setTrackerSelectedEntity: PropTypes.func.isRequired,
    selectedTrackerEntityType: PropTypes.string,
    fetchTrackerTeasersAndTrailers: PropTypes.func.isRequired,
    fetchWordCloud: PropTypes.func.isRequired,
    dailyEngagementTeasersTrailers: PropTypes.object,
    trackerAverageBenchMarkPlan: PropTypes.object,
    trackerAverageBenchMarkTimelineMetrics: PropTypes.object,
    fetchSingleTrackerPlanData: PropTypes.func.isRequired,
    fetchSingleTrackerTimeLineViewData: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      screenWidth: window.innerWidth,
      selectedTrackerEntityName: '',
      selectedTrackerEntityDate: '',
      selectedTrackers: []
    }
  }

  componentDidMount () {
    window.addEventListener('resize', this.updateDimensions)
    document.body.classList.add('trackerBody')
  }

  componentDidUpdate (prevProps) {
    if (prevProps.trackerPlan != this.props.trackerPlan && this.props.trackerPlan.details) {
      const name = this.props.trackerPlan.details.primary_tracker && this.props.trackerPlan.details.primary_tracker.name
      const lookbackDate = this.props.trackerPlan.details.primary_tracker && this.props.trackerPlan.details.primary_tracker.lookback_date
      this.setSelectedTrackerEntityName(name)
      this.setSelectedTrackerEntityDate(lookbackDate)
    }
  }

  updateDimensions = () => {
    this.setState({ screenWidth: window.innerWidth })
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    let trackerName = ''
    if (this.props.trackerPlan && this.props.trackerPlan.details) {
      trackerName = this.props.trackerPlan.details.tracker_topic.tracker_name
    }
    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of content analytics for <strong>{trackerName}</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  _renderOnboarding () {
    let trackerName = ''
    let primaryEntityName = ''
    if (this.props.trackerPlan && this.props.trackerPlan.details) {
      trackerName = this.props.trackerPlan.details.tracker_topic ? this.props.trackerPlan.details.tracker_topic.tracker_name : ''
      primaryEntityName = this.props.trackerPlan.details.primary_tracker ? this.props.trackerPlan.details.primary_tracker.name : ''
    }
    if (!this.props.shortcut) {
      return null
    }
    const name = 'Tracker Tour'
    return (
      <TrackerOnBoarding
        name={name}
        run={true}
        tracker={trackerName}
        primaryEntity={primaryEntityName}
        />
    )
  }

  setSelectedTrackerEntityName = (name) => {
    this.setState({ selectedTrackerEntityName: name })
  }
  setSelectedTrackerEntityDate = (date) => {
    this.setState({ selectedTrackerEntityDate: date })
  }
  updateSelectedTrackers = (trackers) => {
    this.setState({ selectedTrackers: trackers})
  }
  render () {
    if (this.props.tracker && this.props.tracker.isFetching) {
      return (<Spinner />)
    }
    const { classes, history, tracker, trackerPlan, trackerTimelineMetrics, primaryEntityDetails, teasersAndTrailers, dailyEngagementTeasersTrailers, trackerAverageBenchMarkPlan, trackerAverageBenchMarkTimelineMetrics } = this. props
    const date = moment().add(-1, 'days').format('MMM DD, YYYY')
    return (
      <ThemeProvider theme={theme}>
        <div className="rightSide tracker" ref={this.scrollRef}>
          <Container maxWidth="xl" className={classes.containerRoot}>
            {this._renderShortcut()}
            {this._renderOnboarding()}
            <TrackerHeaderComponent
              history={history}
              tracker={tracker}
              trackerPlan={trackerPlan}
              primaryEntityDetails={primaryEntityDetails}
              shortcut={this.props.shortcut}
            />
            <Box className="dateTxt">
              <Typography>Total engagements as of {date}</Typography>
            </Box>
            <Grid container spacing={1} id='dailyEngagement'>
              <Grid item xs={12} lg={12} md={12} sm={12} className='modulePadding dailyEngagement'
                style={{transition: theme.transitions.create('all', {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen
              })}}>
                <TrackerDailyEngagementComponent
                  screenWidth={this.state.screenWidth}
                  trackerId={this.props.trackerId}
                  trackerPlan={trackerPlan}
                  trackerTimelineMetrics={trackerTimelineMetrics}
                  updateSelectedTrackers={this.updateSelectedTrackers}
                  dailyEngagementTeasersTrailers={dailyEngagementTeasersTrailers}
                  trackerAverageBenchMarkPlan={trackerAverageBenchMarkPlan}
                  trackerAverageBenchMarkTimelineMetrics={trackerAverageBenchMarkTimelineMetrics}
                  fetchSingleTrackerPlanData={this.props.fetchSingleTrackerPlanData}
                  fetchSingleTrackerTimeLineViewData={this.props.fetchSingleTrackerTimeLineViewData}
                />
              </Grid>
            </Grid>
            <Paper className="teaserBase">
              <Grid container className="pt-2">
                <Grid item xs={12} lg={12} md={12} sm={12}>
                  <Box className="tabWrapper">
                    <TrackerTabComponent
                      screenWidth={this.state.screenWidth}
                      trackerPlan={trackerPlan}
                      setTrackerSelectedEntity={this.props.setTrackerSelectedEntity}
                      fetchTrackerTeasersAndTrailers={this.props.fetchTrackerTeasersAndTrailers}
                      fetchWordCloud={this.props.fetchWordCloud}
                      setSelectedTrackerEntityName={this.setSelectedTrackerEntityName}
                      setSelectedTrackerEntityDate={this.setSelectedTrackerEntityDate}
                      selectedTrackerEntityType={this.props.selectedTrackerEntityType}
                      selectedTrackers={this.state.selectedTrackers}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={1} id='teasersAndWhatsNew'>
                <Grid item xs={12} lg={12} md={12} sm={12} className='modulePadding'
                  style={{transition: theme.transitions.create('all', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen
                    })}}>
                  <TrackerTeasersTrailersComponent
                    screenWidth={this.state.screenWidth}
                    trackerPlan={trackerPlan}
                    teasersAndTrailers={teasersAndTrailers}
                    selectedTrackerEntityName={this.state.selectedTrackerEntityName}
                    />
                </Grid>
              </Grid>
            </Paper>
          </Container>
        </div>
      </ThemeProvider>
    )
  }
}

export default withStyles(styles)(TrackerComponent)